import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('quindi_token');
    const saved = localStorage.getItem('quindi_user');
    if (token && saved) {
      try {
        setUser(JSON.parse(saved));
      } catch {}
    }
    setLoading(false);
  }, []);

  const login = async (username, password, tenant) => {
    // Salva il tenant per costruire l'URL API corretto
    localStorage.setItem('quindi_tenant', tenant);
    
    const res = await authApi.login(username, password);
    const { token, ruolo, nome, subdomain } = res.data;
    
    localStorage.setItem('quindi_token', token);
    localStorage.setItem('quindi_pass', password); // per auto-refresh token
    const userData = { username, ruolo, nome, subdomain };
    localStorage.setItem('quindi_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('quindi_token');
    localStorage.removeItem('quindi_user');
    localStorage.removeItem('quindi_tenant');
    localStorage.removeItem('quindi_pass');
    setUser(null);
  };

  const isAdmin = user?.ruolo === 'admin';

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
